<template>
  <div>
    <div class="m-auto mb-16" style="max-width: 1100px">
      <div
        class="flex absolute cursor-pointer"
        @click="stepBack"
        style="top: 100px"
      >
        <span class="pt-1 mr-2">
          <img src="@/assets/icons/Back.svg" />
        </span>
        ひとつ前の項目に戻る
      </div>
      <div class="m-auto" style="max-width: 992px">
        <div
          class="flex mb-2 rounded-lg overflow-hidden"
          style="max-height: 68vh"
        >
          <div class="bg-white w-full py-6" style="max-width: 344px">
            <div
              v-for="(item, key) in state.category"
              :key="key"
              class="leading-5 hover:bg-slate-50"
              :style="{
                background: state.selectedClassId === item.id ? '#F8F9FC' : '',
              }"
            >
              <div
                style="margin: 0 38px"
                :style="{
                  'border-top': key > 0 ? '1px solid #e2e8f0' : 'none',
                }"
              >
                <div
                  @click="selectClass(item.id)"
                  class="flex justify-between items-center cursor-pointer"
                  :class="{
                    'font-semibold': state.selectedClassId === item.id,
                  }"
                  style="padding: 10px 6px"
                >
                  <span class="text-gray-92 font-light text-sm">
                    {{ item.name }}
                  </span>
                  <span
                    class="text-gray-62 font-base text-xs font-semibold ml-2"
                  >
                    {{ item.category_number }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-slate-50 overflow-y-scroll scrollbar-gray3">
            <div
              class="flex justify-between flex-wrap divide-y divide-gray-12 w-full"
              style="max-width: 652px; padding: 24px 38px"
            >
              <div
                class="w-full text-right items-start justify-between mb-2 mr-1"
              >
                <label class="text-gray-92">
                  <input
                    type="button"
                    class="bg-transparent cursor-pointer underline hover:no-underline"
                    @click="clickSelectAll()"
                    value="すべて選択/解除"
                  />
                </label>
              </div>
              <div
                class="text-xs w-1/2"
                v-for="category in state.selectedClassCategories"
                :key="category.id"
              >
                <label
                  class="flex items-center hover:bg-slate-100 px-2 h-10 cursor-pointer"
                  :class="{
                    'bg-slate-100':
                      state.checkedCategories.indexOf(category.id) !== -1,
                  }"
                >
                  <BaseCheckbox
                    name="categories"
                    :value="category.id"
                    :checked="
                      state.checkedCategories.indexOf(category.id) !== -1
                    "
                    :on-change="setCategory"
                  >
                    <span class="font-light">{{ category.name }}</span>
                    <span class="text-gray-62 ml-auto font-base font-semibold">
                      {{ category.service_number }}
                    </span>
                  </BaseCheckbox>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white">
      <div class="w-320 mx-auto relative">
        <div class="flex">
          <div class="flex items-center ml-10">
            <div class="text-sm mr-4 mb-1">
              <div
                v-show="state.checkedCategories.length == 0"
                class="text-gray-92 font-semibold"
              >
                1つ以上選択してください。
              </div>
              <div
                v-show="state.checkedCategories.length > 0"
                class="text-gray-92 font-semibold"
              >
                選択中
              </div>
            </div>
            <ul class="flex flex-wrap flex-1">
              <li
                v-for="(id, index) in state.checkedCategories"
                :key="'selected' + index"
              >
                <div
                  class="text-gray-92 text-xs bg-slate-100 rounded p-2 mt-1 mr-1 mb-1"
                >
                  {{ state.categories[id] }}
                </div>
              </li>
            </ul>
          </div>
          <div class="ml-auto">
            <button
              @click="onSubmit"
              :disabled="state.invalid"
              :class="[
                state.invalid
                  ? 'bg-slate-300 cursor-not-allowed'
                  : 'hover:button',
              ]"
              class="px-10 text-white text-base mx-auto bg-coral-main font-semibold focus:outline-none"
              style="min-height: 60px; min-width: 200px"
            >
              この内容で申請
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed, inject, onMounted } from 'vue';

import axios from '@/utils/axios.js';
import BaseCheckbox from '@/components/form/BaseCheckbox.vue';

export default {
  components: {
    BaseCheckbox,
  },
  props: {},
  emits: ['change-view'],
  setup(_, { emit }) {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      category: [],
      categories: {},
      selectedClassId: 0,
      selectedClassCategories: [],
      checkedCategories: [],
      invalid: computed(() => {
        return state.checkedCategories.length == 0;
      }),
    });

    const selectClass = (id) => {
      state.selectedClassId = id;
      state.category.forEach((classOne) => {
        if (classOne.id == state.selectedClassId) {
          state.selectedClassCategories = classOne.categories;
        }
      });
    };

    onMounted(async () => {
      await axios
        .get('/category-classes')
        .then((response) => {
          const { data } = response.data;
          state.category = data;
          data.forEach((classOne) => {
            classOne.categories.forEach((category) => {
              state.categories[category.id] = category.name;
            });
          });
          state.selectedClassId = state.category[0].id;
          state.selectedClassCategories = state.category[0].categories;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    });

    const setCategory = (e) => {
      const { value, checked } = e.target;
      if (checked) {
        state.checkedCategories = [...state.checkedCategories, +value];
        return;
      }
      state.checkedCategories = state.checkedCategories.filter(
        (category) => category !== +value
      );
    };

    const clickSelectAll = () => {
      const checkAll = state.selectedClassCategories.some((value) => {
        return state.checkedCategories.indexOf(value.id) === -1;
      });

      state.selectedClassCategories.forEach((value) => {
        const index = state.checkedCategories.indexOf(value.id);

        if (checkAll && index === -1) {
          state.checkedCategories = [...state.checkedCategories, value.id];
          return;
        }

        if (!checkAll && index !== -1) {
          state.checkedCategories = state.checkedCategories.filter((val) => {
            return val !== value.id;
          });
        }
      });
    };

    const stepBack = () => {
      emit('change-view', { view: 'step3' });
    };

    const onSubmit = () => {
      emit('change-view', {
        view: 'completed',
        inputValues: { request_category_ids: state.checkedCategories },
      });
    };

    return {
      state,
      selectClass,
      setCategory,
      stepBack,
      onSubmit,
      clickSelectAll,
    };
  },
};
</script>

<style lang="scss" scoped>
.scrollbar-gray3 {
  &::-webkit-scrollbar-thumb {
    background: #dde1ed;
  }
}
</style>
